import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import LogoIconContainer from "@/components/ui/logo-icon-container";
import { cn } from "@/utils/utils";
import { APIFieldItem } from "@/pages/settings/types";
import { ScoIllustration, Vector } from "@dreamhub/designsystem/icons";
import { PresetField } from "@/pages/settings/components/dealsSettings/FieldManagement/components/PresetField";

interface AddPresetFieldProps {
  scoFields?: APIFieldItem[];
  onPresetFieldEdit?: (field: APIFieldItem) => void;
}

export const AddPresetField: React.FC<AddPresetFieldProps> = ({
  scoFields,
  onPresetFieldEdit
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "flex w-[460px] flex-col border-[0.5px] border-border-border2 rounded-xl bg-surface-elevation2 "
      )}
    >
      <div className="flex flex-row h-[158px]  pl-4">
        <div className="flex flex-col pt-4 gap-4">
          <LogoIconContainer
            index={-1}
            className="h-8 w-8 rounded-[8px]"
            icon={<Vector />}
            iconSize="sm"
          />
          <Text variant="lgBody">
            {t("settings.deals.fieldManagement.presetFieldTitle")}
          </Text>
        </div>
        <div className="flex">
          <ScoIllustration />
        </div>
      </div>
      <div className="border-[0.5px] border-border-border1" />
      <div className="flex flex-col p-4 gap-5 h-full">
        {scoFields
          ?.filter((field) => !field.showInDetailedView)
          .map((field) => (
            <PresetField
              key={field.id}
              scoField={field}
              onEdit={onPresetFieldEdit}
            />
          ))}
      </div>
    </div>
  );
};
